<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import TopBar from '@/components/TopBar.vue';
import DialogHost from '@/components/DialogHost.vue';
import { useSessionStore } from '@/stores/session';

const route = useRoute();
const session = useSessionStore();
const showChrome = computed(() => !route.meta?.public);
const adminName = computed(() => session.user?.username || '');
</script>

<template>
    <!--
      App shell — tranquil teal backdrop with two soft orbs that anchor
      the brand aesthetic across every view. The orbs sit on a fixed
      layer (z-0) so scrolling stays in front of them; they're skipped
      on `public` routes (login / token-confirm) because those views
      paint their own deeper teal background.
    -->
    <div class="app-shell text-frvb-ink font-sans antialiased">
        <template v-if="showChrome">
            <div class="app-orb app-orb-a" aria-hidden="true"></div>
            <div class="app-orb app-orb-b" aria-hidden="true"></div>
        </template>

        <TopBar v-if="showChrome" />
        <RouterView />
        <footer v-if="showChrome && adminName && session.isAdmin"
                class="relative max-w-7xl mx-auto px-5 py-6 text-xs text-right no-print">
            <div class="text-frvb-ink-soft font-semibold">
                Designations approved by <span class="text-frvb-accent-2">{{ adminName }}</span>
            </div>
        </footer>
        <DialogHost />
    </div>
</template>

<style scoped>
.app-shell {
    position: relative;
    min-height: 100vh;
    overflow-x: hidden;
}
.app-orb {
    position: fixed;
    border-radius: 50%;
    filter: blur(80px);
    pointer-events: none;
    z-index: 0;
}
.app-orb-a {
    width: 520px; height: 520px;
    top: -180px; left: -200px;
    background: rgba(110, 231, 183, 0.22);
}
.app-orb-b {
    width: 620px; height: 620px;
    bottom: -260px; right: -240px;
    background: rgba(5, 150, 105, 0.18);
}
.app-shell > :not(.app-orb) { position: relative; z-index: 1; }
</style>
